import { RenderShowcase } from '@kitup/book-render';
import type { JSX } from 'react';
import { useBrand } from '../brand/context.js';

/** Техническая витрина E10; используется визуальной приёмкой и Playwright. */
export function RenderShowcasePage(): JSX.Element {
  const { name } = useBrand();
  return <RenderShowcase title={`${name} · book-render`} />;
}
